import React, { useState } from "react";
import DrawerFilter from "../../../../../components/listing/DrawerFilter";
import InputNumberNoScroll from "../../../../../components/inputs/inputNumberNoScroll";

export default function FiltroMoneda({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  const [codigo, setCodigo] = useState(initialFilters.codigo || "");
  const [nombre, setNombre] = useState(initialFilters.nombre || "");
  const [valorCambio, setValorCambio] = useState(
    initialFilters.valorCambio || "",
  );
  const [codigoIso, setCodigoIso] = useState(initialFilters.codigoIso || "");

  const handleApply = () => {
    onSubmit({
      codigo: codigo.trim(),
      nombre: nombre.trim(),
      valorCambio: valorCambio === "" ? undefined : Number(valorCambio),
      codigoIso: codigoIso === "" ? undefined : Number(codigoIso),
    });
    onClose();
  };

  return (
    <DrawerFilter
      title="Filtros de Monedas"
      onClose={onClose}
      onApply={handleApply}
    >
      <div className="space-y-4">
        <div>
          <label className="form-label-fil">Código:</label>
          <input
            type="text"
            className="input mt-1 w-full"
            value={codigo}
            onChange={(e) => setCodigo(e.target.value)}
            placeholder="Buscar por código..."
          />
        </div>
        <div>
          <label className="form-label-fil">Descripción:</label>
          <input
            type="text"
            className="input mt-1 w-full"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="Buscar por nombre..."
          />
        </div>
        <div>
          <label className="form-label-fil">Valor Cambio:</label>
          <InputNumberNoScroll
            step="1"
            className="input mt-1 w-full"
            value={valorCambio}
            onChange={(e) =>
              setValorCambio(
                e.target.value === "" ? "" : Number(e.target.value),
              )
            }
            placeholder="Buscar por valor cambio..."
          />
        </div>
        <div>
          <label className="form-label-fil">Código ISO:</label>
          <InputNumberNoScroll
            step="1"
            className="input mt-1 w-full"
            value={codigoIso}
            onChange={(e) =>
              setCodigoIso(e.target.value === "" ? "" : Number(e.target.value))
            }
            placeholder="Buscar por código ISO..."
          />
        </div>
      </div>
    </DrawerFilter>
  );
}
